import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import React from 'react';
import { ViewerControlButtonDownload, ViewerControlsBox } from "../../controls";
import { Slug } from '@isyc-react/animation/modules/base/trail';
import { ViewerArchiveContainer, ViewerDocumentContainer, ViewerControlsContainer } from "../../container";
import { useArchiveLayoutDimensions, offsetHeightHeader } from "../../base/layout";
import { useArchiveMediaViewed } from "../../../hooks";
import "./view-video.style.scss";

// TODO allow native and custom player with custom controls, keep improving, etc ...

export const ViewVideo = props => {
  const {
    file,
    dataRange,
    native = false,
    onViewed
  } = props;
  const {
    layoutDim
  } = useArchiveLayoutDimensions(offsetHeightHeader, 0);
  const {
    onLoadedMetadata,
    onStartedPlaying,
    onStoppedPlaying
  } = useArchiveMediaViewed(onViewed);
  const [src, setSrc] = React.useState(dataRange === null || dataRange === void 0 ? void 0 : dataRange.url);
  const video = React.useRef(null);

  // TODO default name ... with { t }
  const name = React.useMemo(() => {
    var _ref, _file$name;
    return (_ref = (_file$name = file === null || file === void 0 ? void 0 : file.name) !== null && _file$name !== void 0 ? _file$name : dataRange === null || dataRange === void 0 ? void 0 : dataRange.name) !== null && _ref !== void 0 ? _ref : 'video.mp4';
  }, [file, dataRange]);
  React.useEffect(() => {
    if (file && !dataRange) {
      try {
        if (video.current) {
          video.current.srcObject = file;
        }
      } catch (error) {
        if (file) setSrc(URL.createObjectURL(file));
      }
      return () => {
        if (src) URL.revokeObjectURL(src);
      };
    }
  }, [file]);
  const containerDims = React.useMemo(() => {
    return {
      height: `${layoutDim.height}px`,
      width: `${layoutDim.width}px`,
      maxHeight: `${layoutDim.height}px`,
      maxWidth: `${layoutDim.width}px`
    };
  }, [layoutDim]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ViewerArchiveContainer, {
    className: "view-video-container"
  }, /*#__PURE__*/React.createElement(ViewerControlsContainer, {
    className: "view-video-tools"
  }, /*#__PURE__*/React.createElement(ViewerControlsBox, null, /*#__PURE__*/React.createElement(ViewerControlButtonDownload, {
    archive: {
      file,
      httpUrl: dataRange ? {
        url: dataRange.url
      } : undefined
    },
    name: name
  }))), /*#__PURE__*/React.createElement(Slug, {
    delay: 0,
    from: {
      opacity: 0,
      transform: 'translate3d(0,-40px,0)'
    },
    className: "h-100 w-100"
  }, /*#__PURE__*/React.createElement(ViewerDocumentContainer, {
    className: "view-video-document",
    style: containerDims
  }, /*#__PURE__*/React.createElement("video", {
    controls: true,
    playsInline: true,
    ref: video,
    src: src,
    className: "view-video-video",
    onLoadedMetadata: e => {
      onLoadedMetadata(e);
    },
    onPlay: () => {
      onStartedPlaying();
    },
    onPlaying: () => {
      onStartedPlaying();
    },
    onPause: e => {
      onStoppedPlaying(e);
    },
    onEnded: e => {
      onStoppedPlaying(e);
    }
  })))));
};